import LPGlider from 'ui/glider';
import {
	trackVideoThumbnailClick,
	utagLinkPDP,
	utagLinkPLA,
	utagLinkSFP,
	utagViewArtificialPageView
} from 'features/tealium';
import { setGenericEvent, setVideoLoad } from 'features/tealium/ga4/custom';
import { triggerEvent } from 'utilities/dom';
// eslint-disable-next-line no-restricted-imports
import { extractVideoIdFromUrl, injectYouTubeIframeAPI, videoOptions } from 'features/youtube';
import { getPixleeContentFromSku } from 'features/pixlee/api';
import { albumDetailsForPDP } from 'apps/pixlee/constants';
import { getSource, getThumbnailImage } from 'features/pixlee/helpers';
import initGliderSlideVisibleFix from 'features/glider';

import initOptionsSliders from '../initOptionsSliders';

const trackArtificalPageViewEvent = utagViewArtificialPageView();

function prepImgUrlForZoom (imgPath) {

	// remove specified params from query string
	imgPath = imgPath
		.replace(/[qlt]{3}\=[0-9]{1,}/, '') // qlt
		.replace(/[wid]{3}\=[0-9]{1,}/, '') // wid
		.replace(/[hei]{3}\=[0-9]{1,}/, '') // hei
		.replace('fit=constrain', '') // fit constrain
		.replace(/\?\&{1,}/, '?')
		.replace(/\&{1,}/, '&')
		.replace(/\&\&{1,}/, ''); // clean up query string separators like leftover '&' signs

	return imgPath;

}

function initImage () {

	const globals = {
		videoBase: videoOptions.server,
		sceneSevenImageServerCompanyName: window.lp.globals.sceneSevenImageServerCompanyName
	};

	const { page_type, product_category: productCategory = [] } = window.utag_data;
	const pla4Container = document.querySelector('.sfp');
	const showNewUi = document.querySelector('.productImageModal');
	const ui = {
		pdImgContainer: document.querySelector('#pdImgContainer'),
		pdImgThumbnailWrappers: document.querySelectorAll('#pdAddlImgs .thumbnailWrapper'),
		moreImages: document.querySelectorAll('.moreImages'),
		pdAddlImgs: document.getElementById('pdAddlImgs'),
		pdAddlImgsDivs: document.querySelectorAll('#pdAddlImgs > div'),
		pdImgWrap: document.querySelectorAll('.pdImgWrap'),
		thumbnails: document.querySelectorAll('.thumbnailWrapper'),
		printImage: document.querySelector('#pdPrintImage img'),
		pla: document.querySelector('#qlBkg'),
		plaSort: document.querySelector('#sfpQuicklook'),
		imageTabs: document.querySelectorAll('.imageTab'),
		fsContent: document.querySelector('#fsContent'),
		pdVideoPlayerDiv: document.querySelector('.pdVideoPlayer'),
		pdVideoPlayerWrapper: document.querySelector('.pdVideoPlayerWrapper'),
		prevImageModal: document.getElementById('prevImageModal'),
		nextImageModal: document.getElementById('nextImageModal')
	};

	const userType = window.lp.globals;
	const trackGAEvents = ui.pla ? utagLinkPLA() : utagLinkPDP();
	const IMAGE_NAME_REGEX = /^(cropped|views|scenes)\//gi;
	let navArray = [];

	let fsNavGlider;
	let pdVideoPlayer;
	let customPhotoData = { next: true, page: 1 };
	let activeTab = 'photos';
	let lastFocused = null;
	const sliderInfo = {};
	const isPdpPage = page_type === 'product';
	const shortSku = window.shortSku;
	const [ primaryCategory ] = productCategory;
	const isPlaPage = page_type === 'sfp_full' || page_type === 'sfp_partial';

	const fireGA4Event = (eventName, eventdata) => {

		setGenericEvent({
			event_name: eventName,
			...(isPdpPage && { pdp_item_id: shortSku, pdp_prime_cat: primaryCategory }),
			...(isPlaPage && { sfp_item_id: shortSku, sfp_prime_cat: primaryCategory }),
			...eventdata,
		});

	};

	const destroyFsNavGlider = () => {

		fsNavGlider?.destroy();
		fsNavGlider = null;

	};

	const trackHoverGAEvents = {
		modalClosed: true,

		fireGAEvent (e) {

			if (trackHoverGAEvents.modalClosed) {

				const imgFileName = e.currentTarget.querySelector('img').dataset.imgpath.replace(IMAGE_NAME_REGEX, '');
				trackGAEvents({
					eventAction: 'Hover-Thumbnail-Image',
					eventLabel: `${shortSku}-${imgFileName}`
				});
				if (isPdpPage || isPlaPage) {
					fireGA4Event(isPdpPage ? 'pdp_imgthumb_hover' : 'sfp_imgthumb_hover', {
						img_file_name: imgFileName,
					});
				}

			}
			trackHoverGAEvents.removeGAEvents(e);

		},
		removeGAEvents (e) {

			e.currentTarget.removeEventListener('mouseleave', trackHoverGAEvents.fireGAEvent);
			e.currentTarget.removeEventListener('blur', trackHoverGAEvents.fireGAEvent);

		},

		updateModalState (state) {

			this.modalClosed = state;

		},

		getModalState () {

			return this.modalClosed;

		}
	};

	const getHorizontalOffeset = () => {

		if (!showNewUi) return 90;
		const fsNavContentWidth = $(document).width() - 294;
		return 90 + (fsNavContentWidth - Math.floor(fsNavContentWidth / 90) * 90) / 2;

	};

	const getLpModalConfig = () => {

		if (!(window.isIpad() && showNewUi)) {

			return {
				fullScreen: true,
				fullScreenOffset: {
					x: getHorizontalOffeset(),
					y: 50
				}
			};

		}
		const documentWidth = Math.floor($(document).width());
		const windowHeight = Math.floor($(window).height());
		return {
			width: documentWidth - 2 * getHorizontalOffeset() - 60,
			height: windowHeight - (documentWidth > windowHeight ? 200 : 400)
		};

	};

	function initializeNavGlider () {

		const slidesToShow = Math.floor(($(document).width() - getHorizontalOffeset() * 2 - 114) / 90);
		sliderInfo.slidesToShow = slidesToShow;
		const gliderConfig = {
			infinite: false,
			centerMode: false,
			slidesToShow,
			slidesToScroll: slidesToShow,
			arrows: {
				prev: '#fsWrapper .glider-prev',
				next: '#fsWrapper .glider-next'
			}
		};

		const element = document.getElementById('fsNav');
		const gliderInstance = new LPGlider(element, gliderConfig);
		return gliderInstance;

	}

	const saveImagePaths = () => {

		navArray = [];
		// add all image paths to array
		document.querySelectorAll('#fsNav .thumbnailWrapper img').forEach((el) => {

			const tempA = document.createElement('a');
			tempA.href = el.src;

			navArray.push(tempA.pathname);

		});

	};

	const getActiveItemCaption = (photoDetail) => `${photoDetail.user_name}${photoDetail.source && ` | ${getSource(photoDetail.source)}`}`;

	const imageSlideContent = (photoDetail, index) => {

		const { pixlee_cdn_photos, source_url, content_type } = photoDetail;
		const { large_url } = pixlee_cdn_photos;
		const isVideo = content_type === 'video';
		const videoId = extractVideoIdFromUrl(source_url);
		const caption = getActiveItemCaption(photoDetail);
		const altImage = document.querySelector('#imageAltInfo')?.alt || '';
		return `<div class="imageThumbParent">
			<div class="thumbnailWrapper">
				<img itemprop="thumbnail" alt='${altImage}' src="${getThumbnailImage(
	photoDetail
)}" data-imgserverurl="" data-imgpath="${large_url}" data-index="${index}" data-videoId="${videoId}" data-location="preview-modal" data-content-type="${content_type}" data-source-url="${source_url}" data-caption="${caption}" />
				${isVideo ? '<span class="playButton thumbnailPlayButton"></span>' : ''}
			</div>
		</div>`;

	};

	const generateCustomPhotoContent = (photos) => `<div class="sliderContent">
			${photos.reduce((content, photoDetail, index) => `${content}${imageSlideContent(photoDetail, index)}`, '')}
		</div>
		${photos.length > 2 ? '<div class="hasMultiImage"></div>' : ''}
		`;

	const updateCustomPhotoTab = () => {

		const csPhotoTab = document.querySelector('.imageTab--customer');
		const csPhotoTabContent = document.querySelector('.imageTabContent--customer');
		csPhotoTabContent.innerHTML = generateCustomPhotoContent(customPhotoData.data);
		csPhotoTab.classList.remove('hidden');

	};

	const getCustomPhotoData = async (page = 1) => {

		try {

			const { data, next } = await getPixleeContentFromSku({
				...albumDetailsForPDP,
				page,
				perPage: 24,
				productSku: shortSku
			});
			customPhotoData = { data: [ ...(customPhotoData.data || []), ...data ], next, page };
			if (next) getCustomPhotoData(page + 1);
			else if (customPhotoData.data.length) updateCustomPhotoTab();

		} catch (error) {}

	};

	const getContentHeight = (activeTab) => {

		const multipleImages =			activeTab === 'customer' ? customPhotoData.data.length > 1 : window.lp.product.imageCount > 1;
		const leftModalContainer = document.querySelector('.leftModalContainer');
		if (multipleImages) leftModalContainer.classList.remove('hidden');
		else leftModalContainer.classList.add('hidden');
		return document.getElementById('lpModalContent').clientHeight - (showNewUi ? (multipleImages ? 200 : 110) : 70);

	};

	const slideNavGliderIfNotVisible = (slideIndex, animateSlide, isLooping) => {

		if (!fsNavGlider) {

			return;

		}

		const { slidesToShow } = fsNavGlider.opt;
		const firstVisibleSlideIndex = fsNavGlider.slide;
		const lastVisibleSlideIndex = firstVisibleSlideIndex + slidesToShow - 1;

		// scroll to the target slide only if it's not visible in viewport
		if (slideIndex < firstVisibleSlideIndex || slideIndex > lastVisibleSlideIndex || isLooping) {

			if (animateSlide) {

				fsNavGlider.scrollItem(slideIndex, false);

			} else {

				fsNavGlider.setActiveSlide(slideIndex);

			}

		}

	};

	const initVideoPlayer = (videoid) => {

		pdVideoPlayer = new window.YT.Player('pdVideoPlayer', {
			playerVars: window.lp.video.youtube.apiSettings,
			host: 'https://www.youtube-nocookie.com',
			events: {
				onReady: () => {

					loadYTVideo(videoid);

				}
			}
		});

	};

	const stopPdPlayer = () => {

		pdVideoPlayer?.destroy();
		pdVideoPlayer = null;
		ui.pdVideoPlayerWrapper?.classList.add('hidden');
		ui.pdVideoPlayerDiv?.classList.add('hidden');

	};

	const loadYTVideo = (videoid) => {

		let isVideoReady;
		let relaunchVideo;

		const launchPlayer = () => {

			clearInterval(isVideoReady);

			const launch = () => {

				clearInterval(relaunchVideo);

				if (pdVideoPlayer?.loadVideoById) {

					pdVideoPlayer.loadVideoById(videoid);

				} else {

					window.onYouTubeIframeAPIReady = function () {

						pdVideoPlayer.loadVideoById(videoid);

					};

				}

			};

			launch();

			// relaunch the player if it is stuck
			relaunchVideo = setInterval(() => {

				if (pdVideoPlayer?.getPlayerState && pdVideoPlayer?.getPlayerState() === -1) {

					launch();

				}

			}, 500);

		};

		const setPlayerDimension = () => {

			const pdVideoPlayerWrapperWidth = ui.pdVideoPlayerWrapper.clientWidth;
			pdVideoPlayer = pdVideoPlayer.setSize(
				Math.round(pdVideoPlayerWrapperWidth),
				Math.round(pdVideoPlayerWrapperWidth * window.lp.video.youtube.aspectRatio)
			);

		};

		ui.pdVideoPlayerWrapper.classList.remove('hidden');

		if (ui.pdVideoPlayerDiv.tagName === 'DIV') {

			ui.pdVideoPlayerDiv.addEventListener('load', setPlayerDimension);

		}

		ui.pdVideoPlayerDiv.classList.remove('hidden');

		if (pdVideoPlayer) {

			// check if YT was fully loaded
			isVideoReady = setInterval(() => {

				if (pdVideoPlayer?.getPlayerState) {

					launchPlayer();

				}

			}, 500);

		} else {

			initVideoPlayer(videoid);

		}

	};

	const handlePdImgClick = (e) => {

		if (e.type === 'keyup' && e.which !== 13) {

			return;

		}
		const pdProdImg = e.target.closest('.pdImgWrap')?.querySelector('.pdProdImg');
		if (pdProdImg) {

			const { videoid } = pdProdImg.dataset;
			if (videoid) {

				injectYouTubeIframeAPI();
				loadYTVideo(videoid);
				return;

			}

		}
		events.showFullScreenProdImg(e);

	};

	const events = {
		displayMainImage (e, gliderInstance, animateSlide) {

			const { currentTarget } = e;

			ui.pdAddlImgsDivs.forEach((div) => {

				div.classList.remove('active');

			});

			currentTarget.classList.add('active');

			const slideIndex = Number(currentTarget.dataset.index);
			if (animateSlide) {

				gliderInstance.scrollItem(slideIndex);

			} else {

				gliderInstance.setActiveSlide(slideIndex);

			}

			if (trackHoverGAEvents.getModalState()) {

				currentTarget.addEventListener('mouseleave', trackHoverGAEvents.fireGAEvent);
				currentTarget.addEventListener('blur', trackHoverGAEvents.fireGAEvent);

			} else {

				trackHoverGAEvents.updateModalState(true);

			}
			if (pdVideoPlayer?.getPlayerState) {

				const videoid = currentTarget.querySelector('img')?.dataset.videoid;

				if (!videoid) {

					stopPdPlayer();

				}

			}

		},
		trackArtificialPageEvents () {

			if (ui.plaSort) {

				trackArtificalPageViewEvent({ pageName: 'Image Modal - PLA' });

			} else if (ui.pla) {

				trackArtificalPageViewEvent({ pageName: 'Image Modal - Sfp' });

			} else {

				trackArtificalPageViewEvent({ pageName: 'Product Images' });

			}

		},
		showFullScreenProdImg (e) {

			if (e.type === 'keyup' && e.which !== 13) {

				return;

			}

			trackHoverGAEvents.removeGAEvents(e);
			trackHoverGAEvents.updateModalState(false);
			stopPdPlayer();

			let Fs;
			let isVideo;
			let a;

			const arrowClickHandler = (e) => {

				e.preventDefault();
				e.stopImmediatePropagation();
				if (e.keyCode === 13 && !e.target.classList.contains('btnDisabled')) {

					e.target.click();

				}

			};

			const fullScreenInitialization = () => {

				// initially hiding the fullscreen navigation (#fsNav),
				const fsNav = document.querySelector('#fsNav');
				fsNav.classList.add('hidden');

				document.getElementById('fsContent').style.height = `${getContentHeight(activeTab)}px`;

				// initially hiding the previous and next arrows
				if (ui.prevImageModal && ui.nextImageModal) {

					ui.prevImageModal.classList.add('hidden');
					ui.nextImageModal.classList.add('hidden');

				}

				window.setTimeout(() => {

					// Fs.init() will remove the hidden class of #fsNav if there is more than one image to show
					Fs.init();

					destroyFsNavGlider();

					// if there's only one image (most likely in Customer Photos tab), there is no nav
					if ($(fsNav).is(':hidden')) {

						return;

					}

					fsNavGlider = initializeNavGlider();

					initGliderSlideVisibleFix(fsNavGlider);

					document.querySelectorAll('#fsNav .thumbnailWrapper').forEach((el) => {

						el.classList.remove('selectedThumbnail');

						el.setAttribute('tabindex', 0);
						el.addEventListener('click', events.handleThumbnailClick);

						el.addEventListener('keyup', (e) => {

							if (e.which !== 13) {

								return;

							}

							el.click();

						});

						const videoThumbnail = el.querySelector('.playButton');
						if (videoThumbnail) {

							const GAEventParams = {
								eventAction: 'Load-Product-Video',
								eventLabel: shortSku,
								nonInteraction: true
							};
							if (isPdpPage) {

								utagLinkPDP()(GAEventParams);

							} else if (page_type === 'sfp_partial') {

								utagLinkPLA()(GAEventParams);
								setVideoLoad({
									pageType: window.utag_data.page_type,
									section: 'hero images'
								});

							} else if (page_type === 'sfp_full') {

								utagLinkSFP()(GAEventParams);
								setVideoLoad({
									pageType: window.utag_data.page_type,
									section: 'hero images'
								});

							}

						}

					});

					if (ui.prevImageModal && ui.nextImageModal) {

						ui.prevImageModal.classList.remove('hidden');
						ui.nextImageModal.classList.remove('hidden');

					}

					let selectedThumbnail;
					if (isVideo) {

						selectedThumbnail = document.querySelector(
							`#fsNav .thumbnailWrapper img[src*="${globals.videoBase}"]`
						);

					} else {

						selectedThumbnail = document.querySelector(
							`#fsNav .thumbnailWrapper img[src*="${a.pathname}"]`
						);

					}

					if (!selectedThumbnail) {

						selectedThumbnail = document.querySelector('#fsNav .thumbnailWrapper img');

					}

					selectedThumbnail.parentNode.classList.add('selectedThumbnail');

					const defaultSelectedIndex = Math.max(navArray.indexOf(a.pathname), 0);
					slideNavGliderIfNotVisible(defaultSelectedIndex);

				}, 500);

			};

			const fullscreenUnmount = () => {

				Fs.onUnmount();

				// if glider has been initialized before, destroy it
				destroyFsNavGlider();

				// remove click event listener from FS thumbnails on FS close
				document.querySelectorAll('#fsNav .thumbnailWrapper').forEach((el) => {

					el.removeEventListener('click', events.handleThumbnailClick);

				});

				if (ui.prevImageModal && ui.nextImageModal) {

					ui.prevImageModal.removeEventListener('keyup', arrowClickHandler);
					ui.nextImageModal.removeEventListener('keyup', arrowClickHandler);

				}

				trackArtificalPageViewEvent({ pageName: '' });

			};

			const changeImageTab = (tabDetail, initialCall = false) => {

				if (!initialCall && tabDetail.type === 'keydown') {

					if (tabDetail.which === 9 && !tabDetail.target.classList.contains('imageTab--selected')) {

						tabDetail.stopImmediatePropagation();
						tabDetail.preventDefault();
						document.querySelector('.lpModalClose')?.focus();

					}
					if (tabDetail.which !== 13) return;

				}
				const { tabType } = typeof tabDetail === 'string' ? { tabType: tabDetail } : tabDetail.target.dataset;
				activeTab = tabType;
				ui.imageTabs.forEach((tab) => {

					const toBeActiveTab = tab.classList.contains(`imageTab--${tabType}`);
					if (toBeActiveTab) {

						tab.classList.add('imageTab--selected');
						tab.setAttribute('tabindex', 0);

					} else {

						tab.setAttribute('tabindex', -1);
						tab.classList.remove('imageTab--selected');

					}

				});

				destroyFsNavGlider();

				const imageTabContent = document.querySelector(`.imageTabContent--${tabType}`);
				const fsNav = document.querySelector('#fsNav');

				fsNav.innerHTML = '';
				fsNav.innerHTML = imageTabContent.querySelector('.sliderContent').innerHTML;

				document.querySelectorAll('.previewArrows').forEach((arrow) => {

					arrow.classList[imageTabContent.querySelector('.hasMultiImage') ? 'remove' : 'add']('hidden');

				});

				saveImagePaths();

				if (!initialCall) {

					fullscreenUnmount();
					const targetImg = imageTabContent.querySelector('.imageThumbParent:first-child img');
					setFsConfig(targetImg);
					fullScreenInitialization();
					trackGAEvents({
						eventAction: tabType === 'photos' ? 'Click-Product-Photo' : 'Click-Customer Images Tab',
						eventLabel: shortSku
					});
					if(tabType === 'customer') {
						setGenericEvent({
							event_name: isPdpPage ? 'pdp_img_customerphoto_click' : 'sfp_img_customerphoto_click',
							pdp_item_id: shortSku,
							pdp_prime_cat: primaryCategory,
						});
					}

				}

			};

			const changeLastFocus = (ele) => {

				lastFocused = ele;
				const closeBtn = document.querySelector('.lpModalClose');
				if (ele) closeBtn?.classList.add('hideFocus');
				else closeBtn?.classList.remove('hideFocus');

			};

			const tabHandler = (e) => {

				if (e.type === 'keydown' && e.which !== 9) {

					return;

				}
				const imageTab = e.target.closest('.imageTab');
				if (imageTab && !imageTab.classList.contains('imageTab--selected')) {

					e.stopImmediatePropagation();
					document.querySelector('.lpModalClose')?.focus();

				} else if (e.target.closest('.lpModalClose')) {

					if (lastFocused) {

						document.querySelector('.imageTab:not(.imageTab--selected)')?.focus();
						changeLastFocus(null);

					}

				} else {

					changeLastFocus(e.target);

				}

			};

			const clickHandler = (e) => {

				if (e.target.closest('#lpModal')) changeLastFocus(null);

			};

			const setFsConfig = (prodImg) => {

				if (prodImg.dataset.videoid) {

					const { videoid, videoHeadline } = prodImg.dataset;
					window.lp.video.activeVideoHeadline = videoHeadline || '';
					trackVideoThumbnailClick(videoid, { fromModal: false });

				}

				a = document.createElement('a');
				a.href = prodImg.src;

				let imgPath = prodImg.src;
				isVideo = imgPath.indexOf(globals.videoBase) === 0;
				Fs = new window.lp.plugins.FullScreen({
					imageCount: $(ui.pdAddlImgsDivs).is(':hidden') ? 0 : window.lp.product.imageCount,
					isVideo,
					image: prodImg,
					shortSku,
					trackCustomerEvent: activeTab === 'customer'
				});
				const fsNav = document.querySelector('#fsNav');
				const fsNavActiveLinks = fsNav.querySelectorAll('.active');

				if (!isVideo) {

					imgPath = prepImgUrlForZoom(imgPath);

				}

				window.lp.fullscreen = {
					...window.lp.fullScreen,
					videoBase: globals.videoBase,
					isVideo,
					imgPath,
					shortSku,
					videoId: prodImg.dataset.videoid
				};

				if (fsNavActiveLinks) {

					fsNavActiveLinks.forEach((link) => {

						link.classList.remove('active');

					});

				}

			};

			let prodImg;

			if (e.target.className === 'moreImages') {

				const sku =					document.querySelector('#pdProdSku')
					&& document.querySelector('#pdProdSku').getAttribute('content');
				const btnText = e.target.innerText;
				trackGAEvents({ eventAction: 'Click-Thumbnail-Image', eventLabel: `${sku}-More-Images${btnText}` });
				if (isPdpPage || isPlaPage) {
					fireGA4Event(isPdpPage ? 'pdp_imgthumb_click' : 'sfp_imgthumb_click', {
						img_file_name: `More-Images${btnText}`,
					});
				}

			}

			if (e.target.className === 'moreImages' || e.target.className === 'playButton') {

				prodImg = e.target.parentElement.querySelector('img');

			} else {

				prodImg = e.target.src ? e.target : e.target.querySelector('img');

			}

			if (!customPhotoData.data && showNewUi) getCustomPhotoData();
			setFsConfig(prodImg);

			const portrait = window.matchMedia('(orientation: portrait)');

			portrait.addEventListener('change', (e) => {

				if (e.matches && window.isIpad()) {

					if (!showNewUi) $(e.target).lpModalResize({ height: 432, width: 670 });

				}

			});

			const onOrientationChange = () => {

				const lpmodal = $('#lpModal');
				lpmodal.css('visibility', 'hidden');

				destroyFsNavGlider();
				fullscreenUnmount();
				setTimeout(() => {

					lpmodal.lpModalResize(getLpModalConfig());
					setTimeout(() => {

						fullScreenInitialization();
						ui.fsContent.style.cssText = `height: ${getContentHeight()}px;`;
						lpmodal.css('visibility', 'visible');

					}, 500);

				}, 1000);

			};

			if (window.isIpad() && showNewUi) {

				window.addEventListener('orientationchange', onOrientationChange, false);

			}

			$(e.target).lpModal({
				onInit: true,
				...getLpModalConfig(),
				lpModalClass: 'lpModal--alt1', // no border and has different Close button
				content: $('#fs'),
				closeEvt () {

					fullscreenUnmount();

					document.removeEventListener('keydown', tabHandler);
					document.removeEventListener('click', clickHandler);
					changeLastFocus(null);
					ui.imageTabs.forEach((tab) => {

						tab.removeEventListener('click', changeImageTab);
						tab.removeEventListener('keydown', changeImageTab);

					});
					if (window.isIpad() && showNewUi) {

						window.removeEventListener('orientationchange', onOrientationChange, false);

					}

				},
				// afterOpenEvt is buggy despite the timeout length - openEvt seems to work every time
				openEvt () {

					if (showNewUi) {

						changeImageTab('photos', true);
						document.addEventListener('keyup', tabHandler);
						document.addEventListener('click', clickHandler);
						ui.imageTabs.forEach((tab) => {

							tab.addEventListener('click', changeImageTab);
							tab.addEventListener('keydown', changeImageTab);

						});

					}
					if (!userType.isLoggedIn || userType.isProfessional || userType.isCustomer) {

						events.trackArtificialPageEvents();

					}

					fullScreenInitialization();

				}
			});

			const imgFileName = prodImg?.dataset?.imgpath?.replace(IMAGE_NAME_REGEX, '');
			if (e.target.classList.contains('pdProdImg')) {

				trackGAEvents({
					eventAction: 'Click-Hero-Image',
					eventLabel: `${shortSku}-${imgFileName}`
				});
				if ((isPdpPage || isPlaPage) && e.target.className !== 'moreImages') {
					fireGA4Event(isPdpPage ? 'pdp_hero_img_click' : 'sfp_hero_img_click', {
						img_file_name: imgFileName,
					});
				}

			} else if (e?.currentTarget?.querySelector('img')?.classList.contains('gaThumbnail')) {

				trackGAEvents({
					eventAction: 'Click-Thumbnail-Image',
					eventLabel: `${shortSku}-${imgFileName}`
				});

				if (isPdpPage || isPlaPage) {
					fireGA4Event(isPdpPage ? 'pdp_imgthumb_click' : 'sfp_imgthumb_click', {
						img_file_name: imgFileName,
					});
				}

			}

		},
		handleThumbnailClick (e) {

			const skipThumbnailTracking = !e.isTrusted;

			// prevents double-firing if not triggered by user clicking on image thumbnail
			if (!skipThumbnailTracking) {

				const isCustomerPhotoEvent = activeTab === 'customer';
				const imageIndex = e.target.closest('.imageThumbParent').getAttribute('data-gslide');
				const imgFileName = isCustomerPhotoEvent
					? `Customer Image ${+imageIndex + 1}`
					: e.currentTarget.querySelector('img').dataset.imgpath.replace(IMAGE_NAME_REGEX, '');
				const eventDetail = {
					eventAction: isCustomerPhotoEvent ? 'Click-Customer-Photo' : 'Click-Thumbnail-Image-Modal',
					eventLabel: `${shortSku}-${imgFileName}`
				};

				trackGAEvents(eventDetail);

				if (isPdpPage || isPlaPage) {
					fireGA4Event(isPdpPage ? 'pdp_imgthumb_modal_click' : 'sfp_imgthumb_modal_click', {
						img_file_name: imgFileName,
					});
				}

			}

		}
	};

	function initHeroCarousel ({ initialSlideIndex = 0, showArrows = false, draggable = false }) {

		const { pdImgContainer, thumbnails, printImage } = ui;

		const gliderOptions = {
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			rewind: false,
			duration: 0,
			draggable
		};

		if (showArrows) {

			gliderOptions.arrows = {
				prev: '#pdHeroCarouselWrapper .glider-prev',
				next: '#pdHeroCarouselWrapper .glider-next'
			};

			Object.values(gliderOptions.arrows).forEach((selector) => document.querySelector(selector).classList.remove('hidden'));

		}

		pdImgContainer?.addEventListener('glider-loaded', function () {

			const glider = LPGlider(this);
			glider.setActiveSlide(initialSlideIndex);

			pdImgContainer.classList.remove('glider-loading');

		});

		const gliderInstance = new LPGlider(pdImgContainer, gliderOptions);

			// Update other elements as hero image slides
			gliderInstance.ele.addEventListener('glider-slide-visible', function () {

				const nextSlide = gliderInstance.slide;
				const nextSlideElement = thumbnails[nextSlide];

				// Deactivate active thumbnail
				thumbnails.forEach((el) => el.classList.remove('active'));

				// Stop video player
				stopPdPlayer();

				// Activate next thumbnail
				nextSlideElement.classList.add('active');

				// when changing hero image via slider also update print image src to render correct image in print mode
				if (printImage) {

					const glider = LPGlider(this);
					const activeImage = glider.slides[nextSlide].querySelector('.pdProdImg');

					if (activeImage) {

						printImage.src = activeImage.src;

					}

				}

			});

			return gliderInstance;

	}

	function init () {

		initOptionsSliders();

		const {
			pdImgContainer, pdImgThumbnailWrappers, moreImages, pdAddlImgsDivs, pdImgWrap
		} = ui;

		if (pdImgContainer) {

			pdImgContainer.addEventListener(
				'click',
				isPdpPage || isPlaPage ? handlePdImgClick : events.showFullScreenProdImg
			);
			pdImgContainer.addEventListener(
				'keyup',
				isPdpPage || isPlaPage ? handlePdImgClick : events.showFullScreenProdImg
			);

		}

		if (ui.prevImageModal && ui.nextImageModal) {

			ui.prevImageModal.addEventListener('click', () => {

				// get current selected element
				const a = document.createElement('a');
				a.href = document.querySelector('#fsNav .selectedThumbnail img').src;

				// get prev index of thumbnail

				let prevIndex = navArray.indexOf(a.pathname) - 1;
				let isLoopingToLastIndex = false;

				// clicked back on last photo, move to last index
				if (prevIndex === -1) {

					prevIndex = navArray.length - 1;
					isLoopingToLastIndex = true;

				}

				const targetImage = document.querySelector(
					`#fsNav .thumbnailWrapper img[src*="${navArray[prevIndex]}"]`
				);

				const imgFilePath =					activeTab === 'photos'
					? targetImage.dataset.imgpath
					: `Customer Image ${+targetImage.dataset.index + 1}`;

				const trackingData = {
					eventAction: 'Click-Back-Image-Modal',
					eventLabel: `${shortSku}-${imgFilePath}`
				};

				if (pla4Container) trackingData.eventCategory = 'PLA';

				trackGAEvents(trackingData);

				if (isPdpPage || isPlaPage) {
					fireGA4Event(isPdpPage ? 'pdp_imgmodal_back' : 'sfp_imgmodal_back');
				}

				// trigger mouseenter
				triggerEvent.call(targetImage.parentNode, 'click');
				slideNavGliderIfNotVisible(prevIndex, true, isLoopingToLastIndex);

			});

			ui.nextImageModal.addEventListener('click', () => {

				// get current selected element
				const a = document.createElement('a');
				a.href = document.querySelector('#fsNav .selectedThumbnail img').src;

				// get prev index of thumbnail
				let nextIndex = navArray.indexOf(a.pathname) + 1;
				let isLoopingToFirstIndex = false;

				// clicked next on last photo, move to first index
				if (nextIndex === navArray.length) {

					nextIndex = 0;
					isLoopingToFirstIndex = true;

				}
				const targetImage = document.querySelector(
					`#fsNav .thumbnailWrapper img[src*="${navArray[nextIndex]}"]`
				);
				const imgFilePath =					activeTab === 'photos'
					? targetImage.dataset.imgpath
					: `Customer Image ${+targetImage.dataset.index + 1}`;
				const trackingData = {
					eventAction: 'Click-Forward-Image-Modal',
					eventLabel: `${shortSku}-${imgFilePath}`
				};

				if (pla4Container) trackingData.eventCategory = 'PLA';
				trackGAEvents(trackingData);
				if (isPdpPage || isPlaPage) {
					fireGA4Event(isPdpPage ? 'pdp_imgmodal_foward' : 'sfp_imgmodal_foward');
				}

				// trigger mouseenter
				triggerEvent.call(targetImage.parentNode, 'click');
				slideNavGliderIfNotVisible(nextIndex, true, isLoopingToFirstIndex);

			});

			document.addEventListener('keydown', (e) => {

				// don't need to do anything if section is hidden.
				if (document.querySelector('#fs').classList.contains('hidden')) {

					return;

				}
				if (e.keyCode === 37) {

					// left arrow
					ui.prevImageModal.click();

				} else if (e.keyCode === 39) {

					// right arrow
					ui.nextImageModal.click();

				}

			});

		}

		const isIpad = window.isIpad();
		const initialSlideIndex = $(pdImgWrap).filter('.active').data('index');
		if (pdImgContainer) {

			const gliderInstance = initHeroCarousel({ initialSlideIndex, showArrows: isIpad, draggable: isIpad });
			let $gliderSlides = $();

			// Used in Color customized products when switching from the main product to a customized product
			$(ui.pdImgContainer).on('resetHeroCarouselWithOneSlide', () => {

				const slidesToDetach = gliderInstance.ele.querySelectorAll('.glider-slide:not(:first-child)');
				if (slidesToDetach.length === 0) {

					return;

				}

				gliderInstance.scrollItem(0);

				// Detach unused slides from the original product
				$gliderSlides = $(slidesToDetach).detach();
				gliderInstance.refresh(true);

			});

			// Used in Color customized products when switching back from a customized product to the main/original product
			$(ui.pdImgContainer).on('resetHeroCarouselWithOriginalSlides', () => {

				gliderInstance.scrollItem(0);

				// Re-insert the original slides
				$gliderSlides.appendTo(gliderInstance.ele.querySelector('.glider-track'));
				gliderInstance.refresh(true);

			});

			if (isIpad) {

				pdImgThumbnailWrappers.forEach((wrapper) => {

					wrapper.addEventListener('click', (e) => events.displayMainImage(e, gliderInstance, true));

				});

				moreImages.forEach((img) => {

					img.addEventListener('click', events.showFullScreenProdImg);
					img.addEventListener('keyup', events.showFullScreenProdImg);

				});

			} else {

				pdAddlImgsDivs.forEach((div) => {

					div.addEventListener('click', events.showFullScreenProdImg);
					div.addEventListener('keyup', events.showFullScreenProdImg);

				});

				pdImgThumbnailWrappers.forEach((wrapper) => {

					wrapper.addEventListener('mouseenter', (e) => events.displayMainImage(e, gliderInstance, false));
					wrapper.addEventListener('focus', (e) => events.displayMainImage(e, gliderInstance, false));

				});

			}

		}
		saveImagePaths();

		pdImgThumbnailWrappers.forEach((item) => {

			const videoThumbnail = item.querySelector('.playButton');
			if (videoThumbnail) {

				utagLinkPDP()({
					eventAction: 'Load-Product-Video',
					eventLabel: shortSku,
					nonInteraction: true
				});

			}

		});

	}

	return Object.freeze({ init });

}

export default initImage;
